/**
 * For react-bootstrap `Modal` when the dialog must sit above an open note overlay.
 * Paired CSS: `NoteEditorOverlay.css` (`.note-overlay-app-modal-backdrop`, `.note-overlay-app-modal`).
 */
export type NoteOverlayAppModalBootstrapProps = {
  backdropClassName?: string
  customClassName?: string
}

export const noteOverlayAppModalBootstrapProps: Required<
  Pick<
    NoteOverlayAppModalBootstrapProps,
    'backdropClassName' | 'customClassName'
  >
> = {
  backdropClassName: 'note-overlay-app-modal-backdrop',
  customClassName: 'note-overlay-app-modal',
}
